import ConfirmDialog from "./ConfirmDialog";
import React from "react";
import PropTypes from "prop-types";
import { hot } from "react-hot-loader/root";

/**
 * Provides an informational modal with information about a closed virtual kiosk, and a button to clear the modal.
 * @param {bool} checkedIntoService - if the current user is already checked into the selected service
 * @param {function} setDisplayClosed - the function used to close the modal in the parent component
 * @param {bool} shouldDisplay - whether the modal is currently open
 * @returns {JSX.Element} - the modal, which will either be hidden or displayed based on the state of shouldDisplay
 */
const VirtualKioskClosedModal = ({ checkedIntoService, setDisplayClosed, shouldDisplay }) => {
    const descriptionText = () => checkedIntoService ?
        "You are still checked in and cannot check out while the waiting room is closed. " +
        "Someone from the service may contact you. View Virtual Check-in Hours on the Service Profile."
        :
        "You are not able to check in while the waiting room is closed. " +
        "View Virtual Check-in Hours on the Service Profile."

    return <ConfirmDialog
        isOpen={shouldDisplay}
        confirmText="OK, THANKS!"
        headerText="This waiting room is currently closed."
        descriptionText={descriptionText()}
        onConfirm={() => setDisplayClosed(true)}
    />;
}

VirtualKioskClosedModal.propTypes = {
    checkedIntoService: PropTypes.bool.isRequired,
    setDisplayClosed: PropTypes.func.isRequired,
    shouldDisplay: PropTypes.bool.isRequired
}

export default hot(VirtualKioskClosedModal);
